import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { applyMiddleware, combineReducers, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';
import { createWrapper, HYDRATE } from 'next-redux-wrapper';
import reducers from './reducers';
import rootSaga from './sagas';
import TrackingMiddleware from './tracking/middleware';
var combinedReducers = combineReducers(reducers);

// next-redux-wrapper dispatches HYDRATE on the client with the serialized
// server state. The payload is the full store state, so we replace the slices
// with it (mirrors the v4 behaviour where the client store was created from
// the serialized initial state). seamless-immutable reducers accept the plain
// payload slices and re-wrap them on the next action.
var rootReducer = function rootReducer(state, action) {
  if (action.type === HYDRATE) {
    return _objectSpread(_objectSpread({}, state), action.payload);
  }
  return combinedReducers(state, action);
};

// On the client the store must be a singleton so that the sagas (started here)
// and the <Provider> in _app share the exact same instance — otherwise actions
// dispatched by components would never reach the sagas. On the server a fresh
// store is created per request.
var clientStore;
export var makeStore = function makeStore() {
  if (typeof window !== 'undefined' && clientStore) {
    return clientStore;
  }
  var sagaMiddleware = createSagaMiddleware();
  var enhancer = composeWithDevTools(applyMiddleware(sagaMiddleware), applyMiddleware(TrackingMiddleware));
  var store = createStore(rootReducer, enhancer);
  store.saga = sagaMiddleware;
  store.sagaTask = sagaMiddleware.run(rootSaga);
  if (typeof window !== 'undefined') {
    clientStore = store;
  }
  return store;
};
export var wrapper = createWrapper(makeStore);
export default makeStore;